import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup'; // Pour la validation du formulaire
import { useNavigate, useParams } from 'react-router-dom';

// Validation du formulaire avec Yup
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Le nom est requis'),
  obs: Yup.string().required('Observation est requis'),
  libelle: Yup.string().required('Le libellé est requis'),
  interne: Yup.boolean().required('Interne est requis'),
});

function EditEtsouservice() {
  const { id } = useParams(); // Pour récupérer l'ID de l'enregistrement à modifier
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: '',
    obs: '',
    libelle: '',
    interne: false,
  });

  // Récupération des données existantes de l'Etsouservice à modifier
  /* useEffect(() => {
    const fetchEtsouservice = async () => {
      try {
        const response = await fetch(`etsouservice/byid/x/${id}`);
        if (response.ok) {
          const data = await response.json();
          setInitialValues({
            name: data.name || '',
            obs: data.obs || '',
            libelle: data.libelle || '',
            interne: data.interne || '',
          });
        } else {
          console.error('Erreur lors de la récupération des données');
        }
      } catch (error) {
        console.error('Erreur de connexion au serveur', error);
      }
    };
    fetchEtsouservice();
  }, [id]); */
  useEffect(() => {
    const fetchEtsouservice = async () => {
      try {
        const response = await axios.get(`etsouservice/byid/x/${id}`);
        const data = response.data;
        console.log(data);
        setInitialValues({
          name: data.name || '',
          obs: data.obs || '',
          libelle: data.libelle || '',
          interne: data.interne || '',
        });
      } catch (error) {
        console.error(
          error.response?.data?.message || 'Erreur de connexion au serveur',
          error
        );
      }
    };

    fetchEtsouservice();
  }, [id]);
  // Soumission du formulaire
  /*  const onSubmit = async (values, { setSubmitting, setStatus }) => {
     try {
       const response = await fetch(`etsouservice/${id}`, {
         method: 'PUT',
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify(values),
       });
 
       if (response.ok) {
         navigate('/etsouservice'); // Rediriger vers la liste si la mise à jour est réussie
       } else {
         const errorData = await response.json();
         setStatus({
           error: errorData.message || 'Erreur lors de la mise à jour',
         });
       }
     } catch (error) {
       setStatus({ error: 'Erreur de connexion au serveur' });
     } finally {
       setSubmitting(false);
     }
   }; */
  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      await axios.put(`etsouservice/${id}`, values); // Axios gère le JSON automatiquement
      navigate('/etsouservice'); // Rediriger vers la liste si la mise à jour est réussie
    } catch (error) {
      setStatus({
        error:
          error.response?.data?.message || 'Erreur de connexion au serveur',
      });
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <div className="container mt-5 pt-5">
      <h2>Modification SERVICE, ETABLISSEMENT ou BUREAU</h2>
      <Formik
        initialValues={initialValues}
        enableReinitialize // Permet de réinitialiser les valeurs initiales lorsque l'état change
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <div className="form-group">
              <label htmlFor="name">Nom</label>
              <Field className="form-control" name="name" type="text" />
              <ErrorMessage name="name" component="div" className="error" />
            </div>

            <div>
              <label htmlFor="obs">Observation</label>
              <ErrorMessage className="text-danger" name="obs" component="span" />
              <Field className="form-control" as="select" id="obs" name="obs">
                <option value=""></option>
                <option value="SERVICE">SERVICE</option>
                <option value="ETABLISSEMENT">ETABLISSEMENT</option>
                <option value="BUREAU">BUREAU</option>
              </Field>
              <ErrorMessage name="obs" component="div" className="error" />
            </div>

            <div>
              <label htmlFor="libelle">Libellé</label>
              <Field className="form-control" name="libelle" type="text" />
              <ErrorMessage name="libelle" component="div" className="error" />
            </div>

            <div>
              <label htmlFor="interne">Interne</label>
              <ErrorMessage className="text-danger" name="interne" component="span" />
              <Field className="form-control" as="select" id="interne" name="interne">
                <option value="1">OUI</option>
                <option value="0">NON</option>
              </Field>
            </div>

            {status && status.error && <div className="error">{status.error}</div>}

            <button className="btn btn-primary m-4" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'En cours...' : 'Mettre à jour'}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default EditEtsouservice;
